// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 17:59:41

export default {
  "id": "musketeers-gunpowder-vs-steel",
  "slug": "musketeers-gunpowder-vs-steel",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/75b84aa8a9894ade8fc1a8f4235c13c9-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/75b84aa8a9894ade8fc1a8f4235c13c9/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Musketeers Gunpowder vs Steel",
      "description": "Take command in Musketeers: Gunpowder vs Steel, a strategic 17th-century battle experience. Lead musketeers, pikemen, and reiters as a mercenary commander, issuing orders, engaging in combat, and training troops. Master tactics, crush your enemies, and claim victory on the battlefield.",
      "instructions": "Left Mouse Button or Joystick: Control the commander’s movement\nQ: Turn Squad Left\nW: Move Squad Forward\nE: Turn Squad Right\nA: Squad Follows the Player\nS: Stop Squad Movement\nD: Indicate Target for Squad\nX: Move Squad Backwards\nF: Fire Pistol\nV: Mount Horse\nSpace: Switch Camera View",
      "genres": [
        "Strategy"
      ],
      "tags": [
        "historical",
        "real-time-strategy",
        "war"
      ]
    },
    "zh-CN": {
      "title": "火枪手火药VS钢铁",
      "description": "指挥《火枪手：火药对钢铁》，一场17世纪的策略战斗体验。作为雇佣兵指挥官，率领火枪手、长矛兵和骑兵，下达命令、参与战斗和训练部队。掌握战术，击败敌人，在战场上赢得胜利。",
      "instructions": "左鼠标按钮或摇杆：控制指挥官移动\nQ：向左转向小队\nW：向前移动小队\nE：向右转向小队\nA：小队跟随玩家\nS：停止小队移动\nD：指示小队目标\nX：向后移动小队\nF：开枪\nV：骑马\n空格键：切换摄像机视角",
      "genres": [
        "策略"
      ],
      "tags": [
        "历史",
        "实时策略",
        "战争"
      ]
    },
    "zh-TW": {
      "title": "火槍兵的火藥對鋼鐵",
      "description": "領導火槍兵：火藥對鐵砲，一場17世紀的策略戰鬥體驗。扮演傭兵司令，指揮火槍兵、長槍兵和騎兵，下達命令，進行戰鬥，並訓練士兵。精通戰術，擊敗敵人，在戰場上奪取勝利。",
      "instructions": "左鍵或搖桿：控制指揮官的移動\nQ：向左轉 Squad\nW：前進 Squad\nE：向右轉 Squad\nA：Squad 跟隨玩家\nS：停止 Squad 移動\nD：指揮 Squad 目標\nX：後退 Squad\nF：開火手槍\nV：騎上馬匹\n空格鍵：切換相機視角",
      "genres": [
        "策略"
      ],
      "tags": [
        "歷史",
        "即時策略",
        "戰爭"
      ]
    },
    "zh-HK": {
      "title": "Musketeers 火藥 vs 鋼鐵",
      "description": "指揮 Musketeers: Gunpowder vs Steel 的戰略性 17世紀戰鬥體驗。作為傭兵司令，領導火槍兵、長矛兵和騎兵，發布命令、參與戰鬥及訓練部隊。精通戰術，擊敗敵人，在戰場上奪得勝利。",
      "instructions": "左鍵或搖桿：控制指揮官的移動\nQ：將小隊向左轉\nW：讓小隊前進\nE：將小隊向右轉\nA：小隊跟隨玩家\nS：停止小隊移動\nD：標示小隊目標\nX：讓小隊後退\nF：開槍\nV：騎上馬匹\n空格鍵：切換攝影機視角",
      "genres": [
        "策略"
      ],
      "tags": [
        "歷史",
        "實時策略",
        "戰爭"
      ]
    },
    "ja": {
      "title": "ミュッセテールの火薬対鋼鉄",
      "description": "ムッシェルズ：銃と鋼の戦略的な17世紀の戦闘体験を指揮せ。傭兵の指揮官として、ミュッシェル、ピケマン、ライターや兵士を率い、命令を出し、戦闘に参加し、兵士を訓練する。戦術をマスターし、敵を圧倒し、戦場で勝利を手に入れろ。",
      "instructions": "左ボタンまたはジョイスティック：指揮官の移動操作\nQ：小隊を左に旋回\nW：小隊を前方に進む\nE：小隊を右に旋回\nA：小隊がプレイヤーに追随\nS：小隊の移動を停止\nD：小隊の標的を指示\nX：小隊を後方に進む\nF：ピストルを発射\nV：馬に乗る\nスペース：カメラ視点を切り替える",
      "genres": [
        "戦略"
      ],
      "tags": [
        "歴史的",
        "リアルタイムストラテジー",
        "戦争"
      ]
    },
    "ko": {
      "title": "뮤스케터즈 화약 대 철",
      "description": "뮤스케터즈: 탄약 대 철골, 17세기 전략 전투 체험에서 지휘권을 얻어라. mercenary commander로 musketeers, pikemen, reiters를 이끌어 명령을 내리고 전투에 참여하고 부대를 훈련하라. 전술을 익혀 적을 물리치고 전장에서 승리를 거두라.",
      "instructions": "마우스 왼쪽 버튼이나 조이스틱: 지휘관의 이동 제어\nQ: 부대를 왼쪽으로 돌리기\nW: 부대를 앞으로 이동시키기\nE: 부대를 오른쪽으로 돌리기\nA: 플레이어를 따라가는 부대\nS: 부대 이동 중지\nD: 부대의 목표를 지시\nX: 부대를 뒤로 이동시키기\nF: 핸드건 발사\nV:馬에 올라서기\n스페이스바: 카메라 시점 전환",
      "genres": [
        "전략"
      ],
      "tags": [
        "역사적",
        "실시간 전략",
        "전쟁"
      ]
    },
    "fr": {
      "title": "Mousquetaires Poudre à canon vs Acier",
      "description": "Prenez le commandement dans \"Musketeers: Gunpowder vs Steel\", une expérience stratégique de bataille du 17ème siècle. Dirigez des mousquetaires, des piquiers et des hussards en tant que commandant mercenaire, donnez des ordres, engagez-vous dans des combats et formez vos troupes. Maîtrisez les tactiques, écrasez vos ennemis et obtenez la victoire sur le champ de bataille.",
      "instructions": "Bouton Gauche de la Souris ou Manette: Contrôle le déplacement du commandant\nQ: Tourner l'escadron à gauche\nW: Avancer l'escadron\nE: Tourner l'escadron à droite\nA: L'escadron suit le joueur\nS: Arrêter le déplacement de l'escadron\nD: Indiquer la cible à l'escadron\nX: Reculer l'escadron\nF: Tirer avec le pistolet\nV: Monter sur cheval\nEspace: Changer de vue de la caméra",
      "genres": [
        "Stratégie"
      ],
      "tags": [
        "historique",
        "stratégie en temps réel",
        "guerre"
      ]
    }
  }
};
